/* START OF COMPILED CODE */

import { createStatAnimations } from '../util/Animations';
import { loadStatSprites } from '../util/Animations';
import itemDatabase from '../data/items.json';
import InventoryScene from './InventoryScene';
import { getStatsManager } from '../managers/StatsManager';

export default class MenuBarScene extends Phaser.Scene {
    constructor() {
        super({ key: 'MenuBarScene', active: true });
        this.buttons = {};
        this.activeScene = null; // Track currently active scene
    }
    /* START-USER-CODE */

    preload() {
        this.load.image('menu-bg', '/sprites/ui/Menu/MenuBG_Wood.png');
        this.load.image('inventory-icon', '/sprites/ui/Icons/104.png');
        this.load.image('equipment-icon', '/sprites/ui/Icons/41.png');
        // this.load.image('stats-icon', '/sprites/ui/Icons/56.png');
        // this.load.image('map-icon', '/sprites/ui/Icons/101.png');
        this.load.image('settings-icon', '/sprites/ui/Icons/132.png');
        this.load.image('leaderboard-icon', '/sprites/ui/Icons/266.png'); 
        this.load.image('quests-icon', '/sprites/ui/Icons/250.png');
        this.load.audio('openInventory', '/audio/sfx/inventory/openInventory.wav');
        this.preloadInventoryAssets();
        loadStatSprites(this);
    }

    create() {
        //createStatAnimations(this);
        this.cameras.main.setViewport(0, 193, 256, 33);
        const menuBg = this.add.nineslice(
            0,          
            0,          
            'menu-bg',  
            null,       
            256,        
            32,         
            4,         
            4,
            11,
            11
        ).setOrigin(0, 0);

        this.createMenuItem('inventory', 120, 16, true, 'inventory-icon');
        this.createMenuItem('equipment', 140, 16, true, 'equipment-icon');
        // this.createMenuItem('stats', 160, 16, true, 'stats-icon');
        // this.createMenuItem('map', 180, 16, true, 'map-icon');
        this.createMenuItem('quests', 160, 16, true, 'quests-icon');
        this.createMenuItem('leaderboard', 180, 16, true, 'leaderboard-icon');
        this.createMenuItem('settings', 240, 16, true, 'settings-icon');
        this.setupKeyboardInputs();
        // Create stat sprites (initially set to frame 0)
        this.hungerSprite = this.add.sprite(20, 16, "hunger", 0);
        this.hungerSprite.setScale(1);

        this.healthSprite = this.add.sprite(40, 16, "health", 0);
        this.healthSprite.setScale(1);
        
       /*  console.log('🩺 HEALTH SPRITE CREATED:', {
            textureKey: this.healthSprite.texture?.key,
            initialFrame: this.healthSprite.frame?.name,
            frameCount: this.healthSprite.texture?.frameTotal,
            textureExists: this.textures.exists('health'),
            spriteSize: { width: this.healthSprite.width, height: this.healthSprite.height },
            textureSize: { width: this.healthSprite.texture?.source[0]?.width, height: this.healthSprite.texture?.source[0]?.height }
        }); */

        this.energySprite = this.add.sprite(60, 16, "energy", 0);
        this.energySprite.setScale(1);

        // Initialize stats connection
        this.statsManager = getStatsManager();
        this.initializeStatsUI();

        // Listen for scene sleep events to track when scenes are closed
        this.game.events.on('sleep', (scene) => {
            if (scene.scene.key === 'InventoryScene' || scene.scene.key === 'MenuScene') {
                this.activeScene = null;
            }
        });
    }

    createMenuItem(key, x, y, clickable, sprite) {
        const button = this.add.sprite(x, y, sprite)
            .setInteractive()
            .setScale(1/2);

        if (clickable) {
            button.on('pointerover', () => button.setTint(0xdddddd));
            button.on('pointerout', () => button.clearTint());
            button.on('pointerdown', () => this.handleMenuClick(key));
        }

        this.buttons[key] = button;
        return button;
    }

    setupKeyboardInputs() {
        this.input.keyboard.on('keydown-B', () => {
           this.scene.launch("InventoryScene");
           this.sound.play('openInventory', { volume: 0.4 });
        });
    }

    handleMenuClick(key) {
        // Handle leaderboard as external page
        if (key === 'leaderboard') {
            window.open('https://binagotchi.com/leaderboard', '_blank');
            return;
        }

        const isInventory = key === 'inventory';
        const sceneKey = isInventory ? 'InventoryScene' : 'MenuScene';

        // If clicking the currently active menu, close it properly
        if (this.activeScene === key) {
            const targetScene = this.scene.get(sceneKey);
            if (targetScene && targetScene.scene.isActive()) {
                this.scene.sleep(sceneKey);
            }
            this.activeScene = null;
            return;
        }

        // Close any currently open scene before opening a new one
        if (this.activeScene) {
            const currentSceneKey = this.activeScene === 'inventory' ? 'InventoryScene' : 'MenuScene';
            const currentScene = this.scene.get(currentSceneKey);
            if (currentScene && (currentScene.scene.isActive() || currentScene.scene.isSleeping())) {
                this.scene.sleep(currentSceneKey);
            }
        }

        // Reset scene state
        this.activeScene = null;

        // Get or create the target scene
        let targetScene = this.scene.get(sceneKey);
        if (!targetScene) {
            if (isInventory) {
                this.scene.add(sceneKey, InventoryScene, false);
            } else {
                this.scene.add(sceneKey, MenuScene, false);
            }
            targetScene = this.scene.get(sceneKey);
        }

        // Launch the target scene
        if (isInventory) {
            this.scene.launch(sceneKey);
            this.sound.play('openInventory', { volume: 0.4 });
        } else {
            this.scene.launch(sceneKey, { menuType: key });
        }

        this.activeScene = key;
    }
    

    preloadInventoryAssets() {
        // Load inventory assets
        this.load.image('closeButton', '/sprites/ui/Menu/closeButton.png');
        this.load.audio('rustle', '/audio/sfx/inventory/rustle01.wav');

        // Load all item sprites from the database
        if (itemDatabase && itemDatabase.items) {
            // Iterate through each category
            Object.entries(itemDatabase.items).forEach(([category, items]) => {
                // Iterate through items in each category
                Object.entries(items).forEach(([id, item]) => {
                    if (item && item.textureKey && item.spritePath) {
                        try {
                            this.load.image(item.textureKey, item.spritePath);
                        } catch (error) {
                            console.warn(`Failed to load item texture: ${category}_${id}`, error);
                        }
                    } else {
                        console.warn(`Invalid item data for ${category}_${id}:`, item);
                    }
                });
            });
        } else {
            console.error('Invalid or missing items database structure');
        }

        // Load item frames for different rarities
        if (itemDatabase.metadata && itemDatabase.metadata.rarityOrder) {
            itemDatabase.metadata.rarityOrder.forEach(rarity => {
                const frameKey = `itemFrame${rarity}`;
                this.load.image(frameKey, `/sprites/ui/inventory/${frameKey}.png`);
            });
        }
    }

    initializeStatsUI() {
        // Listen for stats updates
        if (this.statsManager) {
            this.statsManager.events.on('stats-updated', this.updateStatSprites, this);
            
            // Update immediately with current stats
            this.updateStatSprites(this.statsManager.getStats());
        }
    }

    updateStatSprites(stats) {
        if (!this.statsManager) return;

        // Get appropriate frames for each stat
        const hungerFrame = this.statsManager.getStatFrame('hunger');
        const healthFrame = this.statsManager.getStatFrame('health');
        const energyFrame = this.statsManager.getStatFrame('energy');
        
        // Update sprite frames
        if (this.hungerSprite) {
            this.hungerSprite.setFrame(hungerFrame);
        }

        if (this.healthSprite) {
            this.healthSprite.setFrame(healthFrame);
        }

        if (this.energySprite) {
            this.energySprite.setFrame(energyFrame);
        }

    }

    shutdown() {
        // Clean up event listeners
        if (this.statsManager) {
            this.statsManager.events.off('stats-updated', this.updateStatSprites, this);
        }
        
        this.game.events.off('sleep');
    }
    /* END-USER-CODE */
}
/* END OF COMPILED CODE */